<template>
    <v-toolbar dark color="#00BEFF" height="62px;" class="toolbar">
    <v-toolbar-title>
            {{ $t("website") }}
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="phone">
        <v-btn icon @click="facebook" style="margin-right:5px">
            <img src="@/assets/medical_cd/facebook.png" class="social" >
        </v-btn>
        <v-btn icon @click="twitter" style="margin-right:5px">
            <img src="@/assets/medical_cd/twitter.png" class="social" >
        </v-btn>
        <v-btn icon @click="linkedin" style="margin-right:5px">
            <img src="@/assets/medical_cd/linkedin.png" class="social">
        </v-btn>
    </v-toolbar-items>
    <v-btn class="mr-1" icon @click="language" style="margin-right:5px">
           <p style="font-size:18px; margin-top:10px">{{langval}}</p>
        </v-btn>
    </v-toolbar>
</template>
<script>
export default {
    data(){
        return{
            langval:'',
        }
    },
    created(){
        const lang = localStorage.getItem('lang')
        lang == 'en' ? this.langval = '中' : this.langval = 'EN'
    },
    methods:{
        language(){
            console.log(this.langval);
            
            if(this.langval=='EN'){
                this.$i18n.locale = 'en'
                localStorage.setItem('lang','en');
                this.langval='中'
            }
            else{
                this.$i18n.locale = 'ch'
                localStorage.setItem('lang','ch');
                this.langval='EN'
            }
            window.location.reload()
        },
        openebm(){
                var url = 'http://www.ebmtech.com/index.php';
                var win = window.open(url, '_blank');
                win.focus();
        },
        facebook(){
            var url = 'https://www.facebook.com/ebmtech';
            var win = window.open(url, '_blank');
            win.focus();
        },
        twitter(){
                var url = 'https://twitter.com/EBM_Tech';
                var win = window.open(url, '_blank');
                win.focus();
        },
        linkedin(){
                var url = 'https://www.linkedin.com/company/ebmtech/';
                var win = window.open(url, '_blank');
                win.focus();
        },
  }
}
</script>
<style scoped>
.mt-1{
    /* margin-top: 21px; */
    margin-left: 10px;
}
.mr-1{
    margin-right: 10px;
}
.social{
    width: 28px;
}
.company{
    font-size: 24px !important;
}
.logo{
    height:62px;
     width:208px;
}
.intro{
    font-size: 24px !important;
    margin-right: 80px;
    margin-left: 32px;
}
.upload{
    font-size: 24px !important;
    margin-right:80px
}
.select{
    width: 60px;
    margin-top: 20px;
    margin-right: 20px;
}
@media (max-width: 1398px) {
.intro{
    margin-right: 60px;
    margin-left: 22px;
}
.upload{
    margin-right:60px
}
}
@media (max-width: 990px){
    .intro{
    margin-right: 20px;
    margin-left: 12px;
    font-size: 20px !important;
}
.upload{
    margin-right:20px;
    font-size: 20px !important;
}
.company{
    font-size: 20px !important;
}
.social{
    width: 28px;
}
.logo{
    height: 52px;
    width: 168px;
}
}
@media (max-width: 809px){
 .intro{
   display: none;
}
.upload{
    display: none;
}
.company{
    display: none;
}
}
@media (max-width: 456px){
    .social{
        width:14px;
        float: right;
    }
    .logo{
    height: 32px;
    width: 108px;
    margin-top: 3px;
}
.phone{
    display: none;
}
}
</style>
